import {Route} from "react-router-dom";
import PrivateRoute from "context/PrivateRoute";
import MainHistoric from "./MainHistoric";
import ViewLogs from "./ViewLogs";
import ViewMeasures from "./ViewMeasures";
import ViewContainerMeasure from "./measures/ViewContainerMeasure";
import ViewRecovery from "./ViewRecovery";
import ViewHistory from "./ViewHistory";

const RoutesAdvanced = () => {
    return (
        <>
            <Route
                path="historic"
                element={
                    <PrivateRoute role="superuser">
                        <MainHistoric />
                    </PrivateRoute>
                }
            />
            <Route
                path="historic/logs"
                element={
                    <PrivateRoute role="superuser">
                        <ViewLogs />
                    </PrivateRoute>
                }
            />
            <Route
                path="historic/history"
                element={
                    <PrivateRoute role="superuser">
                        <ViewHistory />
                    </PrivateRoute>
                }
            />
            <Route
                path="historic/measures"
                element={
                    <PrivateRoute role="superuser">
                        <ViewMeasures />
                    </PrivateRoute>
                }
            />
            <Route
                path="historic/measures/:uidp"
                element={
                    <PrivateRoute role="superuser">
                        <ViewContainerMeasure />
                    </PrivateRoute>
                }
            />
            <Route
                path="historic/recovery"
                element={
                    <PrivateRoute role="superuser">
                        <ViewRecovery />
                    </PrivateRoute>
                }
            />
        </>
    );
};
export default RoutesAdvanced;
